import { useEffect, useState } from "react";

export const InputField = ({ placeholder, value, onChange, name }) => {
  return (
    <input
      placeholder={placeholder}
      className="border border-zinc-200 p-2 rounded-md w-full"
      value={value}
      onChange={onChange}
      name={name}
    />
  );
};

export const SearchableDropdown = ({
  users,
  selectedCompany,
  onSelect,
  setCompanyId,
  setCompanyLocationId,
  setCompanyLocation,
}) => {
  const [searchTerm, setSearchTerm] = useState();
  const [filteredOptions, setFilteredOptions] = useState(users);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setSearchTerm(selectedCompany ? selectedCompany : "");
  }, [selectedCompany]);

  useEffect(() => {
    if (!users || !Array.isArray(users)) {
      setFilteredOptions([]);
      return;
    }
    
    if (!searchTerm || searchTerm.trim() === "") {
      setFilteredOptions(users);
      return;
    }

    const filtered = users.filter(
      (user) =>
        user.company?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.clientName?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchTerm, users]);

  const handleSelect = (user) => {
    if (!user) return;
    
    setSearchTerm(user.company || "");
    onSelect(user.company || "");
    setCompanyId(user.id);
    setCompanyLocationId(user.id);
    setCompanyLocation(
      `${user.address || ""}, ${user.city || ""}, ${user?.state || ""} ${user.zipCode || ""}`.trim()
    );
    setIsOpen(false);
  };

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };
  return (
    <div className="relative w-full">
      <input
        type="text"
        className="py-2 border rounded-md px-2 capitalize w-full"
        value={searchTerm || ""}
        onChange={handleInputChange}
        onClick={() => setIsOpen(true)}
        onBlur={() => {
          // Delay closing to allow click events to fire
          setTimeout(() => setIsOpen(false), 200);
        }}
        placeholder="Select a Company"
        aria-label="Select a company"
      />
      {isOpen && (
        <ul 
          className="absolute z-10 border rounded-md mt-1 bg-white w-full max-h-60 overflow-auto text-nowrap shadow-lg"
          role="listbox"
        >
          {filteredOptions && filteredOptions.length > 0 ? (
            filteredOptions.map((user, index) => (
              <li
                key={user.id || index}
                className="py-2 px-4 hover:bg-gray-200 cursor-pointer flex flex-col"
                onClick={() => handleSelect(user)}
                role="option"
                aria-selected={selectedCompany === user.company}
              >
                <p className="font-semibold">{user?.company || "N/A"}</p>
                <p className="text-sm text-zinc-400">
                  {user.address || ""}, {user.city || ""}, {user?.state || ""} {user.zipCode || ""}
                </p>
              </li>
            ))
          ) : (
            <li className="py-2 px-4 text-gray-500">No options found</li>
          )}
        </ul>
      )}
    </div>
  );
};

export const Button = ({
  onClick,
  label,
  additionalClasses = "",
  children,
}) => {
  return (
    <button
      onClick={onClick}
      className={`border p-2 px-5 rounded-md flex items-center gap-1 font-semibold ${additionalClasses}`}
    >
      {children}
      {label}
    </button>
  );
};
